import ProjectCompanyPage from './project-company-page';
export default ProjectCompanyPage;